import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, MousePointerClickIcon, ShieldQuestionIcon } from 'lucide-react';
export function ProblemSection() {
  const steps = [{
    num: '1',
    title: 'Buscan en Google',
    icon: <SearchIcon className="w-6 h-6 text-primary" data-id="element-142" />
  }, {
    num: '2',
    title: 'Revisan la web',
    icon: <MousePointerClickIcon className="w-6 h-6 text-primary" data-id="element-143" />
  }, {
    num: '3',
    title: 'Deciden si confiar o no',
    icon: <ShieldQuestionIcon className="w-6 h-6 text-primary" data-id="element-144" />
  }];
  return <section className="py-20 bg-light" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-147">
          <motion.h2 className="text-3xl md:text-4xl font-bold text-text mb-6" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-148">
            Muchos negocios pierden clientes por su presencia online
          </motion.h2>
          <motion.p className="text-lg text-gray-600 mb-2" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-149">
            Hoy la mayoría de clientes buscan en Google antes de elegir un
            negocio.
          </motion.p>
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-16" data-id="element-150">
          {steps.map((step, index) => <motion.div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center relative" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1 + 0.2
        }} data-id="element-151">
              <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-10 h-10 bg-primary text-white rounded-full flex items-center justify-center font-bold text-lg border-4 border-light" data-id="element-152">
                {step.num}
              </div>
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4 mt-2" data-id="element-153">
                {step.icon}
              </div>
              <h3 className="text-xl font-semibold text-text" data-id="element-154">{step.title}</h3>
            </motion.div>)}
        </div>

        <motion.div className="max-w-2xl mx-auto text-center bg-red-50 border border-red-100 p-6 rounded-xl" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} data-id="element-155">
          <p className="text-lg font-medium text-red-800" data-id="element-156">
            Si tu negocio no tiene una web profesional, probablemente estás
            perdiendo clientes frente a tu competencia.
          </p>
        </motion.div>
      </div>
    </section>;
}